export function load_company_profile_google_map(component, google_map_api_key) {
  if (!google_map_api_key) return;

  component.register_company_profile_map_callback();
  if (component.google_places_is_ready()) {
    component.initialize_company_profile_map_on_next_tick();
    return;
  }

  const existing_script = document.getElementById('googleMapsScript');
  if (existing_script) {
    existing_script.addEventListener('load', () => component.initialize_company_profile_map_on_next_tick(), { once: true });
    return;
  }

  document.head.appendChild(component.create_google_maps_script());
}

function normalize_profile_type_name(profile_type) {
  return String(profile_type?.name || profile_type?.profile_type || profile_type || '').toLowerCase();
}

function profile_type_value(profile_type) {
  return profile_type?.id ?? profile_type;
}

export function profile_matches_type(profile, name, profile_type_id) {
  const expected_name = String(name || '').toLowerCase();
  const profile_type = profile?.profile_type;

  return normalize_profile_type_name(profile_type) === expected_name ||
    (profile_type_id !== null && String(profile_type_value(profile_type)) === String(profile_type_id));
}
